import { render, staticRenderFns } from "./departmentDialog.vue?vue&type=template&id=2f965ddc&"
import script from "./departmentDialog.vue?vue&type=script&lang=js&"
export * from "./departmentDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports